const indexCache = new Map();
const articleCache = new Map();

function dataUrl(path) {
  const base = process.env.PUBLIC_URL || "";
  return `${base}${path}`;
}

export async function fetchBlogIndex(lang) {
  const key = lang || "es";
  if (indexCache.has(key)) {
    return indexCache.get(key);
  }
  const res = await fetch(dataUrl(`/data/articles/${key}/index.json`));
  if (!res.ok) {
    throw new Error(`blog index ${key}: ${res.status}`);
  }
  const data = await res.json();
  indexCache.set(key, data);
  return data;
}

export async function fetchBlogArticle(lang, slug) {
  const key = `${lang || "es"}:${slug}`;
  if (articleCache.has(key)) {
    return articleCache.get(key);
  }
  const res = await fetch(dataUrl(`/data/articles/${lang || "es"}/${slug}.json`));
  if (!res.ok) {
    throw new Error(`blog article ${slug}: ${res.status}`);
  }
  const data = await res.json();
  articleCache.set(key, data);
  return data;
}

export function clearBlogCache() {
  indexCache.clear();
  articleCache.clear();
}
